import { createContext, useContext } from 'react';
const ON_FILL = 'on-fill';
export const isStyleOnFill = use => use === ON_FILL;
export const CommentsUseStyleContext = /*#__PURE__*/createContext('default');
export const useCommentsUseStyle = () => {
  return useContext(CommentsUseStyleContext);
};